
import { useState } from 'react';
import { Button, Grid, TextField } from '@mui/material';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from 'dayjs';





export const BusquedaSoloFecha = ({ inicio, chageInicio, chageFinal, final }) => {



    const [formInfo, setFormInfo] = useState({ini: inicio, fin: final})
    const { ini, fin } = formInfo;


    const handleChangeFecha = (field) => (value) => {
        if (!value) return;
        setFormInfo((prev) => ({
            ...prev,
            [field]: value.toISOString(),
        }));
    };



    const handleBuscarInfo = (e) => {
        e.preventDefault();
        const start = dayjs(ini).startOf('day');
        const end = dayjs(fin).endOf('day');
        chageInicio(start.toISOString());
        chageFinal(end.toISOString());
    }


    

    return (

        <form onSubmit={ handleBuscarInfo }>
            <Grid container spacing={2} sx={{display:'flex', alignItems:'center', mb:3}}>
                <Grid item xs={12} sm={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Fecha Inicial" 
                            placeholder='Fecha Inicial'
                            value={ini || null}
                            name="ini"
                            onChange={handleChangeFecha('ini')}
                            renderInput={ (params) => <TextField size="small" {...params} fullWidth /> }
                        />
                    </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Fecha Final" 
                            placeholder='Fecha Final'
                            value={fin || null}
                            name="fin"
                            onChange={handleChangeFecha('fin')}
                            renderInput={ (params) => <TextField size="small" {...params} fullWidth /> }
                        />
                    </LocalizationProvider>
                </Grid>
                
                <Grid item xs={12} sm={4}>
                    <Button variant='contained' fullWidth type='submit'>
                        Filtrar....
                    </Button>
                </Grid>

            </Grid>
        </form>
    )
}
